(function () {
  'use strict';
  // separating these methods so that it can be maintainable and so that we know where to look when something goes wrong in displaying the postalcodes in the map
  function postalCodesFactory (Common, apiFactory) {
    const factory = {};
    factory.postalcodesToBeRemoved = []; // this is for ODR

    let suggestions = {
      county: [],
      municipality: [],
      postalcity: [],
      postalcode: [],
      postalcodegroup: []
    };

    const defaultOdrGroup = {
      postalcodes: [],
      postalcodeGroup: []
    };

    function resetSuggestions () {
      suggestions = {
        county: [],
        municipality: [],
        postalcity: [],
        postalcode: [],
        postalcodegroup: []
      };
    }

    function restructureCount (countArr) {
      const newCount = {};

      countArr.forEach((item) => {
        newCount[item.type.toUpperCase()] = item.count;
      });

      return newCount;
    }

    // this is for restructuring the data for display
    function checkAndInsert (item) {
      // making sure that the zipcode does not exist
      if (factory.zipcodes.indexOf(item.postalcode) < 0) {
        if (!factory.selectedAreas[item.county]) {
          factory.selectedAreas[item.county] = {}; // create county object first
          factory.selectedAreas[item.county][item.municipality] = {}; // create municipality object
          factory.selectedAreas[item.county][item.municipality][item.postalcity] = []; // create an array to contain postal codes

          // have a common structure for both ODR and ADR
          // have the view handle the display
          const postalCodeDetails = {
            postalcode: item.postalcode,
            count: restructureCount(item.counts)
          };

          factory.selectedAreas[item.county][item.municipality][item.postalcity].push(postalCodeDetails);
        } else {

          factory.selectedAreas[item.county][item.municipality]
            = factory.selectedAreas[item.county][item.municipality]
              ? factory.selectedAreas[item.county][item.municipality] : {};
          const codes = factory.selectedAreas[item.county][item.municipality][item.postalcity] || [];

          // have a common structure for both ODR and ADR
          // have the view handle the display
          const postalCodeDetails = {
            postalcode: item.postalcode,
            count: restructureCount(item.counts)
          };

          codes.push(postalCodeDetails);
          factory.selectedAreas[item.county][item.municipality][item.postalcity] = codes;
        }

        factory.zipcodes.push(parseInt(item.postalcode));
      }
    }

    function structureListDisplay (res) {
      (res || []).forEach(checkAndInsert);

      Common.set('zipcodes', factory.zipcodes);
      Common.set('selectedAreas', factory.selectedAreas);
    }

    function getObjectKeys (obj) {
      return Object.keys(obj || {});
    }

    function getSearchList () {
      return factory.selectedAreas;
    }

    // this is for restructuring the response data for the suggestion text
    // this will be called after successful api call
    function restructureSuggestions (res) {
      (res || []).forEach((item) => {
        const key = item.type === 'postalcode_group' ? 'postalcodegroup' : item.type;
        suggestions[key].push(item);
      });

      return suggestions;
    }

    function getSuggestions (searchTerm) {
      const data = {
        suggest: searchTerm,
        limit: 10 // for now, we'll see
      };

      return apiFactory.getSearchSuggestions.get(data).$promise;
    }

    function getCodes (searchSelection) {
      // call api here for getting codes
      const data = {
        type: searchSelection.type,
        value: searchSelection.type === 'postalcodegroup' ? searchSelection.id : searchSelection.label
      };

      return apiFactory.getCodesFromSearch.get(data).$promise;
    }

    function getIndexOfPostalCode (county, municipality, city, postalcode) {
      const postalCodes = factory.selectedAreas[county][municipality][city];
      let index = -1;

      postalCodes.some((item, ind) => {
        if (item.postalcode === postalcode) {
          index = ind;
        }

        return index !== -1;
      });

      return index;
    }

    // set zipcodes during page onload
    function setPostalCodesSelectedAreas () {
      factory.zipcodes = Common.get('zipcodes', []);
      factory.selectedAreas = Common.get('selectedAreas', {});
      factory.odrGroup = Common.get('recipients.odrGroup', defaultOdrGroup);
    }

    function getJustCodes (codes) {
      return (codes || []).map((item) => {
        return Number(item.postalcode);
      });
    }

    function removePostalcodesInCity (codes, postalcode) {
      const justCodes = getJustCodes(codes);
      if (postalcode) {
        factory.zipcodes.splice(factory.zipcodes.indexOf(postalcode), 1);
        Common.set('zipcodes', factory.zipcodes);
        return;
      }

      factory.postalcodesToBeRemoved = factory.postalcodesToBeRemoved.concat(justCodes);
      factory.zipcodes = factory.zipcodes.filter((item) => {
        return justCodes.indexOf(item) === -1;
      });

      Common.set('zipcodes', factory.zipcodes);
    }

    function removeCounty (county, removedPostalcodes) {
      // before deleting the county, it should delete all zipcodes under this county from this factory.
      if (!removedPostalcodes) {
        return Object.keys(factory.selectedAreas[county]).forEach((municipality) => {
          removeMunicipality(county, municipality);
        });
      }
      // this will delete the county and its contents
      delete factory.selectedAreas[county];
      Common.set('selectedAreas', factory.selectedAreas);
    }

    function removeMunicipality (county, municipality, removedPostalcodes) {
      // iterate city to remove zipcodes
      if (!removedPostalcodes) {
        Object.keys(factory.selectedAreas[county][municipality]).forEach((city) => {
          removeCity(county, municipality, city);
        });

        return;
      }
      // checks if the county has only one municipality
      if (Object.keys(factory.selectedAreas[county]).length < 2) {
        // remove the county
        return removeCounty(county, removedPostalcodes);
      }

      // remove municipality and its cities
      delete factory.selectedAreas[county][municipality];
      Common.set('selectedAreas', factory.selectedAreas);
    }

    function removeCity (county, municipality, city) {
      // remove all zipcodes in this city
      removePostalcodesInCity(factory.selectedAreas[county][municipality][city]);
      // check if the municipality has only one city
      if (Object.keys(factory.selectedAreas[county][municipality]).length < 2) {
        // remove the municipality
        return removeMunicipality(county, municipality, true);
      }
      // remove city and its postal codes
      delete factory.selectedAreas[county][municipality][city];

      Common.set('selectedAreas', factory.selectedAreas);
    }

    function removePostalCode (county, municipality, city, postalcode) {
      if (factory.selectedAreas[county][municipality][city]) {
        // remove postal codes
        removePostalcodesInCity(factory.selectedAreas[county][municipality][city], postalcode);

        if (factory.selectedAreas[county][municipality][city].length < 2) {
          return removeCity(county, municipality, city);
        }

        const index = getIndexOfPostalCode(county, municipality, city, postalcode);

        factory.selectedAreas[county][municipality][city].splice(index, 1);
        Common.set('selectedAreas', factory.selectedAreas);
      }
    }

    function checkIfParametersExists (county, municipality, city) {
      const countyExists = (factory.selectedAreas || {})[county];
      const municipalityExists = ((factory.selectedAreas || {})[county] || {})[municipality];
      const cityExists = (((factory.selectedAreas || {})[county] || {})[municipality] || {})[city];

      return countyExists && municipalityExists && cityExists;
    }

    function deleteFromSelectedList (county, municipality, city, postalcode) {
      if (county && !municipality && !city && !postalcode)
        return removeCounty(county);

      if (county && municipality && !city & !postalcode)
        return removeMunicipality(county, municipality);

      if (county && municipality && city && !postalcode)
        return removeCity(county, municipality, city);

      if (Object.keys(factory.selectedAreas).length && checkIfParametersExists(county, municipality, city))
        return removePostalCode(county, municipality, city, postalcode);
    }

    function odrGetCodes (searchSelection) {
      // call api here for getting codes
      const data = {
        type: searchSelection.type,
        value: searchSelection.type === 'postalcodegroup' ? searchSelection.id : searchSelection.label,
        odrGroup: factory.odrGroup || defaultOdrGroup
      };

      return apiFactory.odrGetPostalcodes.post(data).$promise;
    }

    function removeAndRegroupCodes (searchSelection) {
      const data = {
        type: searchSelection.type,
        value: searchSelection.label,
        odrGroup: factory.odrGroup || defaultOdrGroup
      };

      if (data.type !== 'postalcode_group' && data.type !== 'county') {
        data.postalcodesToBeRemoved = angular.copy(factory.postalcodesToBeRemoved).join(',');
      }

      resetPostalcodesToBeRemoved();

      return apiFactory.odrRemoveAndGroup.post(data).$promise;
    }

    function resetPostalcodesToBeRemoved () {
      factory.postalcodesToBeRemoved = [];
    }

    function switchAddressType () {
      Common.set('zipcodes', undefined);
      Common.set('recipients.odrGroup', undefined);
      Common.set('recipients.odrFilters', undefined);
      Common.set('recipients.grossAddressCount', 0);
      Common.set('recipients.refinedAddressCount', 0);
      Common.set('recipients.adrData', undefined);
      Common.set('selectedAreas', undefined);

      setPostalCodesSelectedAreas();
    }

    factory.selectedAreas = {};
    factory.structureListDisplay = structureListDisplay;
    factory.getObjectKeys = getObjectKeys;
    factory.getSearchList = getSearchList;
    factory.getSuggestions = getSuggestions;
    factory.resetSuggestions = resetSuggestions;
    factory.getCodes = getCodes;
    factory.setPostalCodesSelectedAreas = setPostalCodesSelectedAreas;
    factory.restructureSuggestions = restructureSuggestions;
    factory.deleteFromSelectedList = deleteFromSelectedList;
    factory.odrGetCodes = odrGetCodes;
    factory.removeAndRegroupCodes = removeAndRegroupCodes;
    factory.resetPostalcodesToBeRemoved = resetPostalcodesToBeRemoved;
    factory.switchAddressType = switchAddressType;

    return factory;
  }

  angular.module('web2print.recipients')
    .factory('postalCodesFactory', postalCodesFactory);
})();
